<div class="account-types-container">
  <h2>Vælg brugertype</h2>
  <div class="account-types-grid">
    @for (type of accountTypes$ | async; track type) {
    <button mat-raised-button (click)="switchToAccount(type)">
      {{ type.name }}
    </button>
    }
  </div>
</div>
